/* ============================================================
   bw-cosy-popdown.js
   Buzzwoo E-Com Kitchen – Cosy Roots Customization
   ------------------------------------------------------------
   1) Modal-Verhalten für das Warenkorb-Popdown (Overlay, Schließen,
      ESC, Scroll-Lock, kein Auto-Close) – unabhängig von Pipelines
      CartPopdown, das nur den Inhalt per Section-Rendering lädt.
   2) „Dazu passend": Produkte mit gleichem Muster/gleicher Farbe aus
      anderen Kategorien (Metafelder custom.kategorie/muster/farbe)
      über die Storefront API, auf Produktseiten vorgeladen.

   Konfiguration kommt aus <script type="application/json"
   data-bw-popdown-config> (snippets/bw-cosy-popdown-init.liquid).
   Doku: snippets/bw-cosy-readme.liquid
   ============================================================ */
(function () {
  'use strict';

  var WRAPPER = '[data-product-add-popdown-wrapper]';
  var MODAL = '.product__popdown__modal';
  var RECO = '[data-product-recommendations]';
  var TOTAL_SLOTS = 8;
  var API_VERSION = '2024-01';

  var cfgEl = document.querySelector('[data-bw-popdown-config]');
  var cfg = {};
  try { cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {}; } catch (e) { cfg = {}; }

  var storeDomain = cfg.shop || (window.Shopify && window.Shopify.shop) || '';
  var token = cfg.token || '';
  var productsPool = null;          // Storefront-Produktliste (Cache)
  var poolPromise = null;
  var renderedCache = {};           // productId -> {title, list} | null

  /* ---------- Hilfsfunktionen ---------- */
  function normalize(value) {
    if (value === null || value === undefined) return '';
    var str = String(value).trim();
    if (str.charAt(0) === '[' && str.charAt(str.length - 1) === ']') {
      try {
        var parsed = JSON.parse(str);
        if (Array.isArray(parsed) && parsed.length) str = String(parsed[0]);
      } catch (e) { /* Rohwert behalten */ }
    }
    return str.toLowerCase();
  }
  function esc(s) {
    return String(s || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  function formatPrice(amount, currency) {
    try {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: currency || 'EUR' }).format(parseFloat(amount));
    } catch (e) { return amount + ' ' + currency; }
  }
  function buildCard(p) {
    var img = p.featuredImage && p.featuredImage.url
      ? '<img class="product__popdown__recommendations__image" src="' + esc(p.featuredImage.url) + '&width=300" alt="' + esc(p.featuredImage.altText || p.title) + '" loading="lazy">'
      : '<div class="product__popdown__recommendations__image"></div>';
    var price = p.priceRange && p.priceRange.minVariantPrice
      ? formatPrice(p.priceRange.minVariantPrice.amount, p.priceRange.minVariantPrice.currencyCode) : '';
    var url = p.onlineStoreUrl || (p.handle ? '/products/' + p.handle : '#');
    return '<li class="product__popdown__recommendations__item">' +
      '<a href="' + esc(url) + '" class="product__popdown__recommendations__link">' + img +
      '<p class="product__popdown__recommendations__title-text">' + esc(p.title) + '</p>' +
      '<p class="product__popdown__recommendations__price">' + price + '</p></a></li>';
  }

  /* ---------- Storefront API ---------- */
  function fetchPage(after) {
    var query = 'query BwReco($first: Int!, $after: String) {' +
      ' products(first: $first, after: $after) { pageInfo { hasNextPage endCursor }' +
      ' edges { node { id title handle onlineStoreUrl availableForSale' +
      ' featuredImage { url altText }' +
      ' priceRange { minVariantPrice { amount currencyCode } }' +
      ' kategorie: metafield(namespace: "custom", key: "kategorie") { value }' +
      ' muster: metafield(namespace: "custom", key: "muster") { value }' +
      ' farbe: metafield(namespace: "custom", key: "farbe") { value } } } } }';
    return fetch('https://' + storeDomain + '/api/' + API_VERSION + '/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': token },
      body: JSON.stringify({ query: query, variables: { first: 250, after: after || null } })
    }).then(function (r) { return r.json(); }).then(function (data) {
      if (!data || !data.data) throw new Error('Storefront API: ' + JSON.stringify(data && data.errors));
      var conn = data.data.products;
      return { products: conn.edges.map(function (e) { return e.node; }), hasNext: conn.pageInfo.hasNextPage, cursor: conn.pageInfo.endCursor };
    });
  }
  function loadPool() {
    if (productsPool) return Promise.resolve(productsPool);
    if (poolPromise) return poolPromise;
    if (!storeDomain || !token) return Promise.resolve([]);
    var all = [];
    function step(cursor) {
      return fetchPage(cursor).then(function (res) {
        all = all.concat(res.products);
        if (res.hasNext && all.length < 750 && res.products.length) return step(res.cursor);
        productsPool = all;
        return all;
      });
    }
    poolPromise = step(null).catch(function (err) {
      console.warn('[bw-cosy-popdown] Storefront API nicht erreichbar:', err);
      poolPromise = null;
      return [];
    });
    return poolPromise;
  }

  /* ---------- Empfehlungslogik (wie im alten Theme) ---------- */
  function pickRecommendations(pool, current) {
    var curId = String(current.id || '');
    var curKat = normalize(current.kategorie), curMus = normalize(current.muster), curFar = normalize(current.farbe);
    if (!curKat && !curMus && !curFar) return [];
    var p1 = [], p2 = [], p3 = [], p4 = [];
    pool.forEach(function (p) {
      if (String(p.id).replace('gid://shopify/Product/', '') === curId) return;
      if (p.availableForSale === false) return;
      var kat = normalize(p.kategorie && p.kategorie.value);
      if (!kat || kat === curKat) return;
      var mus = normalize(p.muster && p.muster.value), far = normalize(p.farbe && p.farbe.value);
      var m = curMus && mus === curMus, f = curFar && far === curFar;
      if (m && f) p1.push(p); else if (m) p2.push(p); else if (f) p3.push(p); else p4.push(p);
    });
    return p1.concat(p2, p3, p4).slice(0, TOTAL_SLOTS);
  }
  function renderFor(current) {
    var key = String(current.id || '');
    if (renderedCache.hasOwnProperty(key)) return Promise.resolve(renderedCache[key]);
    return loadPool().then(function (pool) {
      var picks = pickRecommendations(pool, current);
      var html = picks.length ? '<ul class="product__popdown__recommendations__list" data-recommendations-list>' + picks.map(buildCard).join('') + '</ul>' : null;
      renderedCache[key] = html;
      return html;
    });
  }
  function fillRecommendations(popdown) {
    var box = popdown.querySelector(RECO);
    if (!box) return;
    var current = {
      id: box.getAttribute('data-product-id'),
      kategorie: box.getAttribute('data-product-kategorie'),
      muster: box.getAttribute('data-product-muster'),
      farbe: box.getAttribute('data-product-farbe')
    };
    renderFor(current).then(function (html) {
      if (!html || !popdown.contains(box)) return;
      var content = box.querySelector('.product__popdown__recommendations__content');
      if (content) content.innerHTML = html;
      box.classList.add('is-loaded');
    });
  }

  /* ---------- Modal-Verhalten ---------- */
  var savedOverflow = null;
  function lockScroll() { if (savedOverflow === null) { savedOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden'; } }
  function unlockScroll() { if (savedOverflow !== null) { document.body.style.overflow = savedOverflow; savedOverflow = null; } }

  function openModal(wrapper) {
    wrapper.classList.remove('bw-closing');
    wrapper.classList.add('bw-open');
    lockScroll();
    var modal = wrapper.querySelector(MODAL);
    if (modal) { modal.setAttribute('tabindex', '-1'); try { modal.focus({ preventScroll: true }); } catch (e) { /* noop */ } }
  }
  function closeModal(wrapper) {
    wrapper.classList.remove('bw-open');
    wrapper.classList.remove('is-visible');
    wrapper.classList.add('bw-closing');
    unlockScroll();
    setTimeout(function () { wrapper.classList.remove('bw-closing'); }, 350);
  }
  function wireModal(wrapper) {
    var modal = wrapper.querySelector(MODAL);
    if (!modal) return; // Pipeline-Standard-Popdown, nichts tun
    var closers = wrapper.querySelectorAll('[data-close-popdown]');
    Array.prototype.forEach.call(closers, function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); closeModal(wrapper); });
    });
    var cartBtn = wrapper.querySelector('[data-cart-toggle-button]');
    if (cartBtn) cartBtn.addEventListener('click', function () { closeModal(wrapper); }, true);
    openModal(wrapper);
    // Versandkosten-Balken animieren (Breite aus data-percent)
    var fill = wrapper.querySelector('[data-bw-shipping-fill]');
    if (fill) {
      var pct = parseFloat(fill.getAttribute('data-percent'));
      if (!isNaN(pct)) setTimeout(function () { fill.style.width = Math.max(0, Math.min(100, pct)) + '%'; }, 100);
    }
    fillRecommendations(wrapper);
  }

  function init() {
    var wrapper = document.querySelector(WRAPPER);
    if (!wrapper) return;

    // Pipeline setzt innerHTML nach dem Section-Fetch neu -> darauf reagieren
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].type === 'childList' && mutations[i].addedNodes.length) {
          if (wrapper.querySelector(MODAL) && !wrapper.classList.contains('bw-open')) wireModal(wrapper);
          return;
        }
      }
    });
    observer.observe(wrapper, { childList: true });

    document.addEventListener('keyup', function (e) {
      if ((e.key === 'Escape' || e.code === 'Escape') && wrapper.classList.contains('bw-open')) closeModal(wrapper);
    });

    // Vorladen auf Produktseiten
    if (cfg.product && cfg.product.id && (cfg.product.kategorie || cfg.product.muster || cfg.product.farbe)) {
      var start = function () { renderFor(cfg.product).catch(function () { /* still */ }); };
      if ('requestIdleCallback' in window) window.requestIdleCallback(start, { timeout: 3000 }); else setTimeout(start, 800);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
